import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ConfigurationRoute } from '../../../../providers/semantria-api/configuration-route.service';
import { SemantriaConfiguration } from '../../../../providers/semantria-api/configuration.service';
import { IndustryPack } from '../../../../providers/semantria-api/industry-pack.service';
import { LanguageTemplate } from '../../../../providers/semantria-api/language-template.service';
import { ProjectCollection } from '../../models/project-collection.model';

@EnableClassTelemetry()
@Component({
  selector: 'app-select-collection-configuration-dialog',
  templateUrl: './select-collection-configuration-dialog.component.html',
  styleUrls: ['./select-collection-configuration-dialog.component.scss'],
  standalone: false,
})
export class SelectCollectionConfigurationDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() collection: ProjectCollection;

  @Output() modalClosed = new EventEmitter<string>();

  public selectedRouteConfig: ConfigurationRoute;
  public configurationId: string;

  constructor() {}

  ngOnInit(): void {
    if (this.collection.analyses.length === 1) {
      this.configurationId = this.collection.analyses[0].configId;
    }

    if (this.collection.data.configId && this.collection.data.isAutoAnalyze) {
      this.configurationId = this.collection.data.configId;
    }
  }

  public selectConfig(
    config: SemantriaConfiguration | ConfigurationRoute | LanguageTemplate | IndustryPack
  ) {
    if ('id' in config) {
      let prefix = '';
      if ('isLanguageTemplate' in config) {
        prefix = 'lt:';
      } else if ('isIndustryPack' in config) {
        prefix = 'ip:';
      }
      this.configurationId = prefix + config.id;
    } else {
      this.configurationId = 'cr:' + config.route_id;
      this.selectedRouteConfig = config;
    }
  }

  public selectLanguage(language_id: string): void {
    if (!this.selectedRouteConfig) {
      return;
    }

    const languagePart = language_id !== 'auto' ? `:${language_id}` : '';
    this.configurationId = `cr:${this.selectedRouteConfig.route_id}${languagePart}`;
  }

  public cancel() {
    this.modalClosed.emit(null);
  }

  public save() {
    this.modalClosed.emit(this.configurationId);
  }
}
